import React from "react";
import { CalendarDaysIcon, ClipboardListIcon, GiftIcon, MessageSquareTextIcon, Music2Icon, BoxIcon } from "lucide-react";
type Bonus = {
  icon: BoxIcon;
  title: string;
  value: string;
  description: string;
  imageUrl: string;
};
const bonuses: Bonus[] = [{
  icon: Music2Icon,
  title: 'Playlists Curate per Emozione',
  value: 'Valore €12',
  description: '6 liste con BPM specifico per ogni volume: Flow, Power, Relax. L’atmosfera perfetta senza cercare musica per ore.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/g6wD9Kga2mBdZmWKuL6gvm/3f0766cb-57ab-45d3-a989-20e1aded5481-mockup.webp'
}, {
  icon: ClipboardListIcon,
  title: 'Scheda Anamnesi Professionale',
  value: 'Valore €15',
  description: 'Moduli di salute e consenso informato editabili. Professionalità estrema fin dal primo incontro.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/qSjQs8ZhLpQQhHTxBL3Twg/02dec09a-1fae-4421-a299-e78981bf01df-mockup.webp'
}, {
  icon: GiftIcon,
  title: 'Guida alle Variazioni in 3 Livelli',
  value: 'Valore €25',
  description: 'Trasforma ogni esercizio di Pilates per livello Base, Standard e Pro. Gestisci i gruppi misti con facilità.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/d5gSBAcDgA8SpXAkHUButt/06caba13-a05e-4bc5-99a9-fbe58a748bfe-mockup.webp'
}, {
  icon: CalendarDaysIcon,
  title: 'Calendario Annuale di Pianificazione',
  value: 'Valore €20',
  description: 'Una mappa di 12 mesi: sai esattamente quale volume e quale lezione dare ogni settimana dell’anno.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/sfTVYCoxB5VyKXQ2zG29TK/90cd62ef-cf36-4da7-84e3-1d259c567358-mockup.webp'
}, {
  icon: MessageSquareTextIcon,
  title: 'Script “Prima Lezione Perfetta”',
  value: 'Valore €15',
  description: 'Cosa dire esattamente per convertire una lezione di prova in un’allieva che paga l’abbonamento mensile.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/utMmbWf5gboZA5nB6GHm7R/69be7346-fe83-46a0-bad7-b8a840728945-mockup.webp'
}];
export function BonusSection() {
  return <section className="bg-[#241622] px-5 py-20" data-id="element-1" data-mp="1h2cd3lqsleru">
      <div className="mx-auto max-w-5xl" data-id="element-2" data-mp="1h586qxvlxhah">
        <div className="text-center" data-id="element-3" data-mp="1c395puncawgp">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-4" data-mp="1c6evlc3sm2dh">
            <GiftIcon className="h-4 w-4" data-id="element-5" data-mp="1m2i738kjbdd3" />
            Inclusi oggi senza costi aggiuntivi
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-6" data-mp="ycxdlvqr8xpk">
            Cinque bonus <span className="text-emerald-300" data-id="element-7" data-mp="tem2lhoq4h5r">strategici</span>
          </h2>
          <p className="mt-4 text-sm font-medium text-slate-300" data-id="element-8" data-mp="174z9rhtsjru1">
            Valore reale del pack bonus: €87 — oggi inclusi GRATIS con Pilates
            Pronta.
          </p>
        </div>
        <div className="mt-11 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-9" data-mp="eowwr95oroz5">
          {bonuses.map(({
          icon: Icon,
          title,
          value,
          description,
          imageUrl
        }, index) => <article key={title} className="overflow-hidden border border-emerald-200/20 bg-[#38233c]" data-id="element-10" data-mp="jo81nn8y4zl" data-mpi={index}>
              <img src={imageUrl} alt={`Mockup del bonus: ${title}`} width={1024} height={1024} loading="lazy" className="aspect-square w-full object-cover" data-id="element-11" data-mp="5amrux7g1l7l" />
              <div className="p-6" data-id="element-12" data-mp="3moi4bd6niz52">
                <div className="flex items-center justify-between gap-4" data-id="element-13" data-mp="3rp652qkomuch">
                  <span className="grid h-11 w-11 place-items-center border border-emerald-300/40 bg-emerald-400/10" data-id="element-14" data-mp="3rncu4z31dnyo">
                    <Icon className="h-5 w-5 text-emerald-300" data-id="element-15" data-mp="o8p92ptr2duu" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-16" data-mp="9bq5re5xl766">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </p>
                </div>
                <div className="mt-6" data-id="element-17" data-mp="2u1xg2llh335q">
                  <span className="border border-emerald-300/40 px-2 py-1 text-[10px] font-bold uppercase text-emerald-200" data-id="element-18" data-mp="2u0w4mg0joenh">
                    {value} — Gratis oggi
                  </span>
                  <h3 className="mt-4 text-lg font-bold text-white" data-id="element-19" data-mp="3f98367jmw0h3">{title}</h3>
                  <p className="mt-2 text-sm font-medium leading-relaxed text-slate-300" data-id="element-20" data-mp="3agwt4bv6iyat">
                    {description}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}